<template>
  <div>
    <div style="display: none">
      <div id="report_holder"></div>
    </div>
    <el-row type="flex" :gutter="20" justify="space-between">
      <el-col :span="3">
        <el-row>
          <el-col :span="12">
            <el-input
              v-model="SearchVehicleErpCodeLeft"
              placeholder="搜索"
            ></el-input>
          </el-col>
          <el-col :span="12">
            <el-button icon="el-icon-refresh" @click.native="changeCar">
              刷新
            </el-button>
          </el-col>
        </el-row>
        <!-- 左侧车辆 -->
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="collapseItem[0]"
            :name="index"
            v-for="(collapseItem, index) in leftCollapseTitle"
            :key="index"
          >
            <div class="car-area">
              <el-dropdown
                trigger="click"
                v-for="car in collapseCarInfo[collapseItem[1]]"
                :key="car.Id + '_leftkey'"
                @command="carBack($event, car)"
              >
                <div
                  @click="showMenu(car)"
                  class="car-btn"
                  @mousedown="move"
                  draggable="true"
                  @dragstart="drag($event, car.Id)"
                  v-show="
                    SearchVehicleErpCodeLeft == '' ||
                    (car.ErpCode + '').includes(SearchVehicleErpCodeLeft)
                  "
                >
                  {{ car.ErpCode }}
                </div>
                <el-dropdown-menu slot="dropdown">
                  <!-- 0:待排，100：停用，200：维修，300：排队接料中，400：运输途中 -->
                  <el-dropdown-item command="1">回站</el-dropdown-item>
                  <el-dropdown-item command="999">退转料</el-dropdown-item>
                  <el-dropdown-item command="0">待排</el-dropdown-item>
                  <el-dropdown-item command="100">停用</el-dropdown-item>
                  <el-dropdown-item command="200">维修</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
      <el-col :span="21">
        <!-- 中间内容 -->
        <el-row>
          <el-col :span="8">
            <el-date-picker
              v-model="planDateArr"
              type="datetimerange"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getTaskList()"
            ></el-date-picker>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="taskStatus"
              @change="getTaskList()"
              placeholder="任务状态"
            >
              <el-option label="所有" :value="-1"></el-option>
              <el-option label="已开盘" :value="0"></el-option>
              <el-option label="未开盘" :value="100"></el-option>
              <el-option label="暂停" :value="200"></el-option>
              <el-option label="完成" :value="300"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-input
              placeholder="工程/客户/标题/任务单编号"
              v-model="searchText"
              class="input-with-select"
              @change="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
          </el-col>
          <el-col :span="2"></el-col>
          <el-col :span="2">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看所有在生产的发货单"
              placement="top-start"
            >
              <el-button
                icon="el-icon-search"
                circle
                @click.native="
                  drawer = true;
                  taskdetail('');
                "
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row type="flex" justify="flex-start" class="task-area">
          <el-col
            :span="6"
            class="task"
            v-for="item in taskList"
            :key="item.Id + '_contenttask'"
          >
            <el-card
              class="box-card"
              @click.native="taskdetail(item.Id)"
              @drop.native="drop($event, item)"
              @dragover.native="allowDrop($event)"
            >
              <el-row type="flex" justify="space-between">
                <el-col>
                  <span class="pointer" @click="drawer = true">
                    【{{
                      (item.Title == null ? "" : item.Title) + "" + item.Code
                    }}】
                  </span>
                  <span>
                    <el-tag
                      size="small"
                      :type="
                        item.TaskStatus == 0
                          ? 'success'
                          : item.TaskStatus == 100
                          ? 'info'
                          : item.TaskStatus == 200
                          ? 'warning'
                          : item.TaskStatus == 300
                          ? ''
                          : 'danger'
                      "
                    >
                      {{
                        item.TaskStatus == 0
                          ? "已开盘"
                          : item.TaskStatus == 100
                          ? "未开盘"
                          : item.TaskStatus == 200
                          ? "暂停"
                          : item.TaskStatus == 300
                          ? "完成"
                          : "未设置"
                      }}
                    </el-tag>
                  </span>
                </el-col>
                <el-col :span="2">
                  <i
                    class="el-icon-circle-plus-outline pointer"
                    @click="showProdOutMaster(item)"
                  ></i>
                </el-col>
                <el-col :offset="1" :span="2">
                  <el-dropdown
                    trigger="click"
                    @command="taskMenu($event, item)"
                  >
                    <i class="el-icon-more-outline pointer"></i>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        icon="el-icon-s-management"
                        command="-99"
                      >
                        历史出货单
                      </el-dropdown-item>
                      <el-dropdown-item icon="el-icon-s-management" command="0">
                        开盘
                      </el-dropdown-item>
                      <el-dropdown-item
                        icon="el-icon-s-management"
                        command="100"
                      >
                        未开盘
                      </el-dropdown-item>
                      <el-dropdown-item
                        icon="el-icon-s-management"
                        command="200"
                      >
                        暂停
                      </el-dropdown-item>
                      <el-dropdown-item
                        icon="el-icon-s-management"
                        command="300"
                      >
                        完成
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
              <el-row>
                <div class="info">
                  <div class="row">
                    <span class="key">客户</span>
                    <span class="value">{{ item.ClientName }}</span>
                  </div>
                  <div class="row">
                    <span class="key">工程</span>
                    <span class="value">{{ item.ProjectName }}</span>
                  </div>
                  <div class="row">
                    <span class="key">部位</span>
                    <span class="value">{{ item.ProjectPart }}</span>
                  </div>
                  <div class="row between">
                    <span>
                      <span class="key">标号</span>
                      <span class="value">
                        {{ item.GradeName }}/{{ item.SpecMtlName }}
                      </span>
                    </span>
                    <span>
                      <span class="key">泵送方式</span>
                      <span class="value">{{ item.WorkMethodName }}</span>
                    </span>
                  </div>
                </div>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div class="info">
                    <span style="color: red">计划</span>
                    <div class="row">
                      <span class="key">创建</span>
                      <span class="value">
                        {{ timeToMDHm(item.CreateTime) }}
                      </span>
                    </div>
                    <div class="row">
                      <span class="key">开盘</span>
                      <span class="value">{{ timeToMDHm(item.PlanDate) }}</span>
                    </div>
                    <div class="row">
                      <span class="key">方量</span>
                      <span class="value">{{ item.PlanQuantity }}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="info">
                    <span style="color: green">完成</span>
                    <div class="row">
                      <span class="key">发货</span>
                      <span class="value">
                        {{ timeToMDHm(item.UpdateTime) }}
                      </span>
                    </div>
                    <div class="row">
                      <span class="key">车次</span>
                      <span class="value">{{ item.VehiclesTotal }}</span>
                    </div>
                    <div class="row">
                      <span class="key">方量</span>
                      <span class="value">{{ item.QuantityTotal }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <div class="progress-area">
                  <el-col :span="7">完成情况</el-col>
                  <el-col :span="17">
                    <el-progress
                      :text-inside="true"
                      :stroke-width="20"
                      :percentage="
                        item.PlanQuantity > 0 && item.QuantityTotal > 0
                          ? Math.ceil(
                              (item.QuantityTotal / item.PlanQuantity) * 100
                            ) > 100
                            ? 100
                            : Math.ceil(
                                (item.QuantityTotal / item.PlanQuantity) * 100
                              ) < 0
                            ? 0
                            : Math.ceil(
                                (item.QuantityTotal / item.PlanQuantity) * 100
                              )
                          : 0
                      "
                    ></el-progress>
                  </el-col>
                </div>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-size.sync="pageSize"
            :total="total"
            :page-sizes="[6, 10, 15, 20]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            class="my-pagination"
          ></el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
      <!-- 右侧内容 -->
      <el-row>
        <div class="station-area">
          <div
            v-for="item in prodOutMasterList"
            :key="item.Id + '_rightMaster'"
            class="station-card"
          >
            <el-row
              type="flex"
              justify="space-between"
              class="station-card-row"
            >
              <el-col :span="3">
                <el-dropdown
                  trigger="click"
                  @command="stationLineMenu($event, item)"
                  class="dropdown-btn"
                >
                  <span
                    class="btn"
                    :class="
                      item.Status == 0
                        ? 'green'
                        : item.Status == 100
                        ? 'red'
                        : item.Status == 200
                        ? 'blue'
                        : 'yellow'
                    "
                  >
                    {{
                      item.Status == 0
                        ? "新建单据"
                        : item.Status == 100
                        ? "正在生产"
                        : item.Status
                        ? "已完成"
                        : item.Status == 300
                        ? "已出站"
                        : item.Status == 400
                        ? "回站未签收"
                        : item.Status == 500
                        ? "已签收"
                        : item.Status == 900
                        ? "已结算"
                        : "未定义"
                    }}
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-download" command="1">
                      回站
                    </el-dropdown-item>
                    <el-dropdown-item icon="el-icon-error" command="2">
                      取消
                    </el-dropdown-item>
                    <el-dropdown-item icon="el-icon-printer" command="3">
                      打印
                    </el-dropdown-item>
                    <el-dropdown-item icon="el-icon-tickets" command="4">
                      详情
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <el-col :span="7">
                <span style="color: #23ade5" title="工程名称">
                  {{ item.ProjectName }}
                </span>
              </el-col>
              <el-col :span="6">
                <span>发货:{{ item.QuantityDelivery }}方</span>
              </el-col>
              <el-col :span="6">
                <span>时间:{{ timeToMDHm(item.ProductionTime) }}</span>
              </el-col>
              <!-- <el-button plain size="mini">生产中</el-button> -->
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              class="mt10 station-card-row"
            >
              <el-col :span="6">
                <span>车号:{{ item.VehicleErpCode }}</span>
              </el-col>
              <el-col :span="6">
                <span>司机:{{ item.DriverName }}</span>
              </el-col>
              <el-col :span="6">
                <span>强度{{ item.GradeName }} / {{ item.SpecMtlName }}</span>
              </el-col>
              <el-col :span="6">
                <span>生产线:{{ item.StationLineName }}</span>
              </el-col>
            </el-row>
            <el-progress
              :percentage="Number(computeProdSpeed(item))"
            ></el-progress>
          </div>
        </div>
      </el-row>
    </el-drawer>
    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      top="5vh"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="车辆选择" prop="VehicleErpCode">
              <el-input
                v-model="SearchVehicleErpCode"
                class="hr-select"
                placeholder="搜索"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <div class="add-dialog-car-area">
              <el-radio-group
                v-model="addForm.VehicleID"
                @change="changeVehicle"
              >
                <el-radio
                  v-show="
                    SearchVehicleErpCode == '' ||
                    (item.ErpCode + '').includes(SearchVehicleErpCode)
                  "
                  v-for="item in WaitVehicle"
                  :label="item.Id"
                  :key="item.Id + '_addcar'"
                  border
                  size="medium"
                >
                  {{ item.ErpCode }}
                </el-radio>
              </el-radio-group>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="司机选择" prop="DriverName"></el-form-item>
          </el-col>
          <el-col :span="13">
            <div class="add-dialog-driver-area">
              <el-radio-group
                v-model="addForm.DriverID"
                @change="changeVehicleWorker"
              >
                <el-radio
                  v-for="item in VehicleWorker"
                  :label="item.Id"
                  :key="item.Id + '_worker'"
                  border
                  size="medium"
                >
                  {{ item.WorkerName }}
                </el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :span="7">
            <el-input v-model="addForm.DriverName" readonly class="hr-select">
              <template slot="append">
                <el-button type="primary" @click="hrvisibleDialog = true">
                  其他司机
                </el-button>
              </template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="司机选择" prop="DriverName">
              <el-input v-model="addForm.DriverName" readonly class="hr-select">
                <template slot="append">
                  <el-button type="primary" @click="hrvisibleDialog = true">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="9">
            <el-form-item label="操作员选择" prop="OperatorName">
              <el-input v-model="addForm.OperatorName" readonly>
                <template slot="append">
                  <el-button @click="opvisibleDialog = true">选择</el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="3">
            <el-button
              type="primary"
              @click.native="addSubmit"
              :loading="addLoading"
            >
              提交调度
            </el-button>
            <el-button type="danger" @click.native="addFormVisible = false">
              取消调度
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产线">
              <el-select
                v-model="addForm.StationLineID"
                placeholder="请选择"
                @change="selectStation"
              >
                <el-option
                  v-for="item in stationLineDispatch"
                  :key="item.Id + '_addstation'"
                  :label="item.Name"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="票据类别" prop="BillType">
              <el-select v-model="addForm.BillType" placeholder="请选择类别">
                <el-option label="送料" :value="0"></el-option>
                <el-option label="砂浆" :value="100"></el-option>
                <el-option label="拉水" :value="200"></el-option>
                <el-option label="补方" :value="300"></el-option>
                <el-option label="其他" :value="400"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="施工部位" prop="ProjectPart">
              <el-input v-model="addForm.ProjectPart"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="施工单位">
              <el-input v-model="addForm.ProjectCmpy"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="施工地址">
              <el-input v-model="addForm.ProejctAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="强度等级">
              <template>
                <el-select
                  v-model="addForm.GradeID"
                  filterable
                  placeholder="请选择"
                  @change="selectGrade"
                >
                  <el-option
                    v-for="item in baseData.GradeList"
                    :key="item.Id + '_qd'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货方量">
              <el-input v-model="addForm.QuantityDelivery"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="混凝土方量">
              <el-input
                v-model="addForm.TQuantity"
                @input="changequantity"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="砂浆方量">
              <el-input
                v-model="addForm.SQuantity"
                @input="changequantity"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="特殊材料">
          <el-checkbox-group v-model="specMtlIDList">
            <el-checkbox
              v-for="item in baseData.SpecialMaterialList"
              :label="item.Id"
              :key="item.Id + '_ts'"
              @change="changeSpecialMaterial(item, $event)"
            >
              {{ item.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="打印抬头">
              <el-input v-model="addForm.PrintTitle"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="addForm.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input v-model="addForm.ContactsName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <el-input v-model="addForm.ContactsPhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="运输距离">
              <el-input v-model="addForm.Distance"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <TableDataDialog
      title="司机选择"
      :visibleDialog="hrvisibleDialog"
      :queryMethod="hrqueryData"
      :columns="{
        Name: {
          label: '姓名',
        },
        Code: {
          label: '工号',
        },
        Remark: {
          label: '备注',
        },
        WorkStatus: {
          label: '在职状态',
          filter: (item) => {
            return item.WorkStatus == 0
              ? '实习'
              : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
              ? '正式'
              : item.WorkStatus == 3
              ? '临时'
              : item.WorkStatus == 4
              ? '离职'
              : '退休';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="hrsetVisible"
      @callback="hrdialogCallback"
    ></TableDataDialog>

    <TableDataDialog
      title="操作员选择"
      :visibleDialog="opvisibleDialog"
      :queryMethod="opqueryData"
      :columns="{
        Name: {
          label: '姓名',
        },
        Code: {
          label: '工号',
        },
        Remark: {
          label: '备注',
        },
        WorkStatus: {
          label: '在职状态',
          filter: (item) => {
            return item.WorkStatus == 0
              ? '实习'
              : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
              ? '正式'
              : item.WorkStatus == 3
              ? '临时'
              : item.WorkStatus == 4
              ? '离职'
              : '退休';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="opsetVisible"
      @callback="opdialogCallback"
    ></TableDataDialog>

    <TableDataDialog
      title="车辆选择"
      :visibleDialog="vevisibleDialog"
      :queryMethod="vequeryData"
      :columns="{
        Name: {
          label: '设备名称',
        },
        ErpCode: {
          label: '自编号',
        },
        License: {
          label: '车牌号',
        },
        Code: {
          label: '编号',
        },
        CarStatus: {
          label: '设备状态',
          filter: (item) => {
            return item.CarStatus == 0
              ? '待排'
              : item.CarStatus == 100
              ? '停用'
              : item.CarStatus == 200
              ? '维修'
              : item.CarStatus == 300
              ? '排队接料中'
              : item.CarStatus == 400
              ? '运输途中'
              : '未定义';
          },
        },
        CarType: {
          label: '车辆类型',
          filter: (item) => {
            return item.CarType == 0
              ? '搅拌车'
              : item.CarType == 100
              ? '泵车'
              : '其他类型';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="vesetVisible"
      @callback="vedialogCallback"
    ></TableDataDialog>

    <el-dialog
      title="查看历史出货单"
      :visible.sync="historyListShow"
      width="90%"
      top="5vh"
    >
      <ProdOutMater
        v-if="historyListShow"
        :type="2"
        :pagecode="selectCode"
      ></ProdOutMater>
    </el-dialog>

    <!-- 耗料详情 -->
    <el-dialog
      title="耗料详情"
      :visible.sync="manufactureFormVisible"
      v-model="manufactureFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <table class="table-bordered">
        <tr>
          <th>出货单号</th>
          <td>{{ manufactureMaster.Code }}</td>
          <th>生产时间</th>
          <td>{{ manufactureMaster.ProductionTime }}</td>
          <th>回站时间</th>
          <td>{{ manufactureMaster.BackTime }}</td>
        </tr>
        <tr>
          <th>任务名称</th>
          <td>{{ manufactureMaster.TaskCode }}</td>
          <th>施工配比</th>
          <td>{{ manufactureMaster.RecipeCode }}</td>
          <th>合同编号</th>
          <td>{{ manufactureMaster.ContractCode }}</td>
        </tr>
        <tr>
          <th>客户名称</th>
          <td colspan="2">{{ manufactureMaster.ClientName }}</td>
          <th>施工配比</th>
          <td colspan="2">{{ manufactureMaster.ProjectName }}</td>
        </tr>
        <tr>
          <th>工程地址</th>
          <td colspan="2">{{ manufactureMaster.ProejctAddress }}</td>
          <th>票据类别</th>
          <td colspan="2">
            {{
              manufactureMaster.BillType == 0
                ? "送料"
                : manufactureMaster.BillType == 100
                ? "砂浆"
                : manufactureMaster.BillType == 200
                ? "拉水"
                : manufactureMaster.BillType == 300
                ? "补方"
                : manufactureMaster.BillType == 400
                ? "其他"
                : "未定义"
            }}
          </td>
        </tr>
        <tr>
          <th>施工单位</th>
          <td colspan="2">{{ manufactureMaster.ProjectCmpy }}</td>
          <th>施工部位</th>
          <td colspan="2">{{ manufactureMaster.ProjectPart }}</td>
        </tr>
        <tr>
          <th>强度等级</th>
          <td>{{ manufactureMaster.GradeName }}</td>
          <th>特殊材料</th>
          <td>{{ manufactureMaster.SpecMtlName }}</td>
          <th>浇筑方式</th>
          <td>{{ manufactureMaster.PouringMethodName }}</td>
        </tr>
        <tr>
          <th>发货方量</th>
          <td>{{ manufactureMaster.QuantityDelivery }}</td>
          <th>混凝土方量</th>
          <td>{{ manufactureMaster.TQuantity }}</td>
          <th>砂浆方量</th>
          <td>{{ manufactureMaster.SQuantity }}</td>
        </tr>
        <tr>
          <th>累计车次</th>
          <td>{{ manufactureMaster.OutCountItemNumber }}</td>
          <th>累计方量</th>
          <td>{{ manufactureMaster.VehiclesTotal }}</td>
          <th>单价</th>
          <td>{{ manufactureMaster.Price }}</td>
        </tr>
        <tr>
          <th>司机</th>
          <td>{{ manufactureMaster.DriverName }}</td>
          <th>车号</th>
          <td>{{ manufactureMaster.VehicleErpCode }}</td>
          <th>运距</th>
          <td>{{ manufactureMaster.Distance }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="5">{{ manufactureMaster.Remark }}</td>
        </tr>
      </table>
      <div
        v-for="item in Prodmanufacturemains"
        :key="item.Prodmanufacturemain.Id"
      >
        <el-divider content-position="left">
          第{{ item.Prodmanufacturemain.NowItemNum }}盘 -
          {{ item.Prodmanufacturemain.RecipeName }}
        </el-divider>
        <el-table
          :data="item.Prodmanufacturesubs"
          border
          show-summary
          style="width: 100%"
        >
          <el-table-column prop="MatName" label="物资名称"></el-table-column>
          <el-table-column prop="WarehouseName" label="仓库"></el-table-column>
          <el-table-column prop="Quantity" label="理论用量"></el-table-column>
          <el-table-column
            prop="ActualQuantity"
            label="实际用量"
          ></el-table-column>
          <el-table-column
            prop="QuantityRate"
            label="误差率%"
          ></el-table-column>
        </el-table>
      </div>
      <table class="table-bordered">
        <tr>
          <th>容重(理论)实际</th>
          <td>
            {{ ProdRecipeMain.QuantityRecipeSum }}/{{
              ProdRecipeMain.QuantityActualSum
            }}kg
          </td>
          <th>砂率</th>
          <td>{{ ProdRecipeMain.ProdRecipe.TSL }}%</td>
          <th>水胶比</th>
          <td>{{ ProdRecipeMain.ProdRecipe.TSJB }}</td>
        </tr>
        <tr>
          <th>F掺量</th>
          <td>{{ ProdRecipeMain.ProdRecipe.TFProportion }}</td>
          <th>K掺量</th>
          <td>{{ ProdRecipeMain.ProdRecipe.TKProportion }}</td>
          <th>A掺量</th>
          <td>{{ ProdRecipeMain.ProdRecipe.TAProportion }}</td>
        </tr>
      </table>
    </el-dialog>

    <!-- 退转料 -->
    <el-dialog
      title="退转料"
      :visible.sync="transferFormVisible"
      v-model="transferFormVisible"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :model="oldProdOutMasterForm"
        label-width="120px"
        :rules="transferFormRules"
        ref="oldProdOutMasterForm"
      >
        <el-divider content-position="left">出货单信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="oldProdOutMasterForm.ClientName"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本车车号">
              <el-input
                v-model="oldProdOutMasterForm.VehicleErpCode"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工程名称">
              <el-input
                v-model="oldProdOutMasterForm.ProjectName"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本车司机">
              <el-input
                v-model="oldProdOutMasterForm.DriverName"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="发货方量">
              <el-input
                v-model="oldProdOutMasterForm.QuantityDelivery"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产方量">
              <el-input v-model="oldProdOutMasterForm.TQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签收方量">
              <el-input
                v-model="oldProdOutMasterForm.SigningQuantity"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="强度等级">
              <el-input
                v-model="oldProdOutMasterForm.GradeName"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">退转料信息</el-divider>
        <el-row>
          <el-col :span="24">
            <el-form-item label="转料类型">
              <template>
                <el-radio-group v-model="returandtransferrecord.ReturnType">
                  <el-radio :label="0">盘盈转料</el-radio>
                  <el-radio :label="100">废料</el-radio>
                  <el-radio :label="200">整车转料</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="本次退转方量">
              <el-input
                v-model="returandtransferrecord.RemainQuantity"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车辆剩余方量">
              <el-input v-model="returandtransferrecord.Quantity"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="退转备注">
              <el-input v-model="returandtransferrecord.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="单据处理">
              <template>
                        
                <el-radio-group
                  v-model="returandtransferrecord.ToType"
                  @change="changeToType()"
                >
                  <el-radio :label="0">转入车辆</el-radio>
                  <el-radio :label="100">生成出货单</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="newtaskShow">
          <el-col>
            <el-form-item label="任务选择" prop="ProjectName">
              <el-input
                v-model="newProdOutMasterForm.TaskCode"
                readonly
                class="hr-select"
              >
                <template slot="append">
                  <el-button
                    class="pd-5"
                    type="primary"
                    @click="tzlvisibleDialog = true"
                    :loading="listLoading"
                  >
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="newtaskShow">
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="newProdOutMasterForm.ClientName"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工程名称">
              <el-input
                v-model="newProdOutMasterForm.ProjectName"
                readonly
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="司机选择" prop="DriverName">
              <el-input
                v-model="newProdOutMasterForm.DriverName"
                readonly
                class="hr-select"
              >
                <template slot="append">
                  <el-button
                    class="pd-5"
                    type="primary"
                    @click="tzlhrvisibleDialog = true"
                  >
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车辆选择" prop="VehicleErpCode">
              <el-input
                v-model="newProdOutMasterForm.VehicleErpCode"
                readonly
                class="hr-select"
              >
                <template slot="append">
                  <el-button class="pd-5" @click="tzlvevisibleDialog = true">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="transferFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="transferSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
    <!-- 任务选择-退转料 -->
    <TableDataDialog
      title="任务选择"
      :visibleDialog="tzlvisibleDialog"
      :queryMethod="tzlqueryData"
      :columns="{
        Title: {
          label: '任务名称',
        },
        ClientName: {
          label: '客户名称',
        },
        ProjectName: {
          label: '工程名称',
        },

        ProjectPart: {
          label: '施工部位',
        },
        Remark: {
          label: '备注',
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建人',
        },
      }"
      @getDialogVisible="tzlsetVisible"
      @callback="tzldialogCallback"
    ></TableDataDialog>

    <TableDataDialog
      title="车辆选择"
      :visibleDialog="tzlvevisibleDialog"
      :queryMethod="tzlvequeryData"
      :columns="{
        Name: {
          label: '设备名称',
        },
        ErpCode: {
          label: '自编号',
        },
        License: {
          label: '车牌号',
        },
        Code: {
          label: '编号',
        },
        CarStatus: {
          label: '设备状态',
          filter: (item) => {
            return item.CarStatus == 0
              ? '待排'
              : item.CarStatus == 100
              ? '停用'
              : item.CarStatus == 200
              ? '维修'
              : item.CarStatus == 300
              ? '排队接料中'
              : item.CarStatus == 400
              ? '运输途中'
              : '未定义';
          },
        },
        CarType: {
          label: '车辆类型',
          filter: (item) => {
            return item.CarType == 0
              ? '搅拌车'
              : item.CarType == 100
              ? '泵车'
              : '其他类型';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="tzlcarVisible"
      @callback="tzlvcallback"
    ></TableDataDialog>

    <TableDataDialog
      title="司机选择"
      :visibleDialog="tzlhrvisibleDialog"
      :queryMethod="tzlhrqueryData"
      :columns="{
        Name: {
          label: '姓名',
        },
        Code: {
          label: '工号',
        },
        Remark: {
          label: '备注',
        },
        WorkStatus: {
          label: '在职状态',
          filter: (item) => {
            return item.WorkStatus == 0
              ? '实习'
              : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
              ? '正式'
              : item.WorkStatus == 3
              ? '临时'
              : item.WorkStatus == 4
              ? '离职'
              : '退休';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="tzlhrsetVisible"
      @callback="tzlhrdialogCallback"
    ></TableDataDialog>
  </div>
</template>

<script>
import {
  getVehicleListPage,
  getTaskListPage,
  getProdConsoleListPage,
  getGetProdOutMasterBaseData,
  addVehicleDispatch,
  putProdConsoleCancelOutMaster,
  putProdConsoleBackOutMaster,
  putackVehicle,
  getWaitVehicle,
  getVehicleWorker,
  getLastOutMasterByVehicleId,
  getProdSchedule,
} from "../../api/ProdConsole";
import { getSysStationLineListPage } from "../../api/recipe";
import {
  getPrintContent,
  SaveTransfer,
  getManufactureDetail,
} from "../../api/prodoutmaster";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
import {
  getVehicleListPage as VehicleListPage,
  editVehicle,
} from "../../api/vehicle";
import TableDataDialog from "../../components/TableDataDialog";
import ProdOutMater from "../../components/ProdOutMater";
import { getProdTaskListPage, editProdTask } from "../../api/prodTask";
import util from "../../../util/date";
import printJS from "print-js";
import { runReport } from "../../api/viewReport";
export default {
  components: { TableDataDialog, ProdOutMater },
  // watch: {
  //   addForm: {
  //     handler(newName, oldName) {
  //       console.log(JSON.parse(JSON.stringify(newName)));
  //     },
  //     deep: true,
  //   },
  // },
  data() {
    return {
      activeNames: [0, 1],
      leftCollapseTitle: [
        ["站内待命", "WaitVehicleList"],
        ["执行任务", "OutVehicleList"],
        ["正常休息", "DisabledVehicleList"],
        ["检修", "RepairVehicleList"],
      ],
      baseData: [],
      specMtlIDList: [],
      specMtlName: [],
      specMtlID: [],
      collapseCarInfo: {},
      searchText: "",
      taskStatus: -1,
      taskList: [],
      stationLine: [],
      stationLineDispatch: [],
      total: 0,
      page: 1,
      pageSize: 6,
      listLoading: false,
      orgId: "",
      orgCode: "",
      orgName: "",
      currentTaskId: "",
      addFormVisible: false, //新增界面是否显示
      addForm: {
        BillType: 0,
        GradeID: "",
        DriverID: 0,
      },
      addFormRules: {
        StationLineID: [
          { required: true, message: "请选择生产线", trigger: "blur" },
        ],
        ProjectPart: [
          { required: true, message: "请输入部位", trigger: "blur" },
        ],
      },
      addLoading: false,
      hrvisibleDialog: false, //司机列表选择
      opvisibleDialog: false, //操作员列表选择
      vevisibleDialog: false, //车辆列表选择
      selectCode: null,
      historyListShow: false,
      SearchVehicleErpCode: "", //搜索车辆
      SearchVehicleErpCodeLeft: "", //左侧搜索车辆
      WaitVehicle: [], //待排车辆列表
      VehicleWorker: [], //当班司机
      checktask: {}, //当前选中任务单
      prodOutMasterList: [], //当前任务单出货单
      Prodmanufacturemains: [
        {
          Prodmanufacturemain: {},
          Prodmanufacturesubs: [],
        },
      ],
      ProdRecipeMain: {
        ProdRecipe: {
          TSL: 0,
          TSJB: 0,
          TFProportion: 0,
          TKProportion: 0,
          TAProportion: 0,
        },
        prodRecipeSubs: [],
        QuantityRecipeSum: 0,
        QuantityActualSum: 0,
      },
      manufactureFormVisible: false,
      manufactureMaster: {},
      isShowDetail: false,
      checkVehicleId: "",
      transferFormRules: {},
      transferFormVisible: false, //退转料
      oldProdOutMasterForm: {}, //退转料原出货单
      newProdOutMasterForm: {}, //退转料新出货单
      returandtransferrecord: { ReturnType: 0, ToType: 0 }, //退转料实体
      tzlvisibleDialog: false,
      newtaskShow: false,
      tzlvevisibleDialog: false,
      tzlhrvisibleDialog: false,
      prodScheduleList: [], //生产进度
      prodScheduleAuto: null, //生产进度获取线程
      vehicleAuto: null, //获取车辆信息线程
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      planDateArr: [],
      drawer: false,
    };
  },
  computed: {},
  // watch: {
  //   stationLine(val) {
  //     console.log(this.stationLine, val);
  //   },
  // },
  mounted() {
    if (this.orgId == "") {
      if (localStorage.currentOrg) {
        let currentOrg = JSON.parse(localStorage.currentOrg);
        this.orgId = currentOrg.Id;
        this.orgCode = currentOrg.OrgCode;
        this.orgName = currentOrg.Name;
      } else if (localStorage.sysOrgs) {
        let sysOrgs = JSON.parse(localStorage.sysOrgs);
        this.orgId = sysOrgs[0].Id;
        this.orgCode = sysOrgs[0].OrgCode;
        this.orgName = sysOrgs[0].Name;
      }
    }

    this.Init();

    var that = this;
    //当前页面监视键盘输入
    document.onkeydown = function (e) {
      //事件对象兼容
      let e1 = e || window.event || arguments.callee.caller.arguments[0];
      //键盘按键判断:+号为107
      //左
      if (e1 && e1.keyCode == 107) {
        if (that.checktask && that.checktask.Id && that.checktask.Id > 0) {
          that.showProdOutMaster(that.checktask);
        }
      }
    };
  },
  methods: {
    // 拖拽
    drag(ev, id) {
      this.id = id;
      this.dom = ev.currentTarget.cloneNode(true);
    },
    // 允许放下拖拽
    allowDrop(ev) {
      ev.preventDefault();
    },
    // 放下事件
    drop(ev, item) {
      ev.preventDefault();
      let treeNode = ev.target;
      if (treeNode) {
        this.checkVehicleId = this.id;
        this.checktask = item;
        this.showProdOutMaster(item);
      }
    },

    move(e) {
      let odiv = e.target; //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = (e) => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    Init() {
      this.getVehicleList();
      this.getTaskList();
      this.getBaseData();
      this.getSysStationLineList();
      this.GetProdSchedule();
      this.taskdetail("");
    },

    // 事件操作-----------
    carBack(index, car) {
      if (index == 1) {
        this.$confirm(`确认回站${car.ErpCode}？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            //todo 回站事件
            this.backVehicle(car.Id);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消回站",
            });
          });
      }
      //0:待排，100：停用，200：维修，300：排队接料中，400：运输途中
      if (index == 0 || index == 100 || index == 200) {
        car.CarStatus = index;
        let para = Object.assign({}, car);
        editVehicle(para)
          .then((res) => {
            if (res && res.data && res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .finally(() => {
            this.getVehicleList();
          });
      }
      //打开退转料页面
      if (index == 999) {
        let para = { vehicleId: car.Id };
        getLastOutMasterByVehicleId(para).then((res) => {
          if (res.data && res.data.response && res.data.response.Id > 0) {
            this.transferFormVisible = true;
            this.returandtransferrecord = {
              ReturnType: 0,
              ToType: 0,
              Quantity: 0,
            };
            this.newtaskShow = false;
            //获取此车辆剩余方量
            this.returandtransferrecord.Quantity = car.RemainQuantity;
            this.specMtlIDList = res.data.response.SpecMtlID;
            this.oldProdOutMasterForm = res.data.response;
            this.newProdOutMasterForm = JSON.parse(
              JSON.stringify(res.data.response)
            );
          } else {
            this.$message({
              message: "此车辆无待退转的单据",
              type: "error",
            });
          }
        });
      }
    },
    /*退转料 */
    tzlhrdialogCallback(data) {
      if (data.length > 0) {
        this.newProdOutMasterForm.DriverID = data[0].Id;
        this.newProdOutMasterForm.DriverName = data[0].Name;
      }
      this.tzlhrvisibleDialog = false;
    },
    tzlhrqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    tzlhrsetVisible(val) {
      this.tzlhrvisibleDialog = val;
    },
    tzlvcallback(data) {
      if (data.length > 0) {
        this.newProdOutMasterForm.VehicleID = data[0].Id;
        this.newProdOutMasterForm.VehicleErpCode = data[0].ErpCode;
        this.returandtransferrecord.Quantity = data[0].RemainQuantity;
      }
      this.tzlvevisibleDialog = false;
    },
    tzlvequeryData(params) {
      return VehicleListPage(params);
    },
    tzlcarVisible(val) {
      this.tzlvevisibleDialog = val;
    },
    tzldialogCallback(data) {
      if (data.length > 0) {
        this.newProdOutMasterForm.TaskID = data[0].Id;
        this.newProdOutMasterForm.TaskCode = data[0].Code;
        this.newProdOutMasterForm.ProjectID = data[0].ProjectID;
        this.newProdOutMasterForm.ProjectName = data[0].ProjectName;
        this.newProdOutMasterForm.ClientID = data[0].ClientID;
        this.newProdOutMasterForm.ClientName = data[0].ClientName;
        this.newProdOutMasterForm.ProjectPart = data[0].ProjectPart;
      }
      this.tzlvisibleDialog = false;
    },
    tzlqueryData(params) {
      let taskparams = {
        page: 1,
        key: "",
        orgCode: this.orgCode,
        intPageSize: 20,
      };
      taskparams.key = params.key;

      return getProdTaskListPage(taskparams);
    },
    tzlsetVisible(val) {
      this.tzlvisibleDialog = val;
    },
    changeToType() {
      if (this.returandtransferrecord.ToType == 0) {
        this.newtaskShow = false;
      } else {
        this.newtaskShow = true;
      }
    },
    transferSubmit() {
      this.$refs.oldProdOutMasterForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          this.newProdOutMasterForm.SigningQuantity = 0;
          this.newProdOutMasterForm.PlcSOutMasterCode = null;
          this.newProdOutMasterForm.PlcOutMasterCode = null;
          this.newProdOutMasterForm.ProductionTime = null;
          this.newProdOutMasterForm.BackTime = null;
          var dm = {
            NewProdOutMaster: this.newProdOutMasterForm,
            OldProdOutMaster: this.oldProdOutMasterForm,
            ReturAndTransferRecord: this.returandtransferrecord,
          };
          let para = Object.assign({}, dm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          SaveTransfer(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["oldProdOutMasterForm"].resetFields();
                this.transferFormVisible = false;
                this.getProdOutMaster();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    /*退转料 */
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getTaskList();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getTaskList();
    },
    // 数据获取0-------------
    // 获取车辆信息
    getVehicleList() {
      if (this.vehicleAuto) {
        clearTimeout(this.vehicleAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        getVehicleListPage()
          .then((res) => {
            if (res && res.data && res.data.response) {
              this.collapseCarInfo = res.data.response;
            }
          })
          .finally(() => {
            this.vehicleAuto = setTimeout(() => {
              this.getVehicleList();
            }, 10000);
          });
      }
    },
    // 获取生产进度
    GetProdSchedule() {
      if (this.prodScheduleAuto) {
        clearTimeout(this.prodScheduleAuto);
      }
      let that = this;
      if (that && !that._isDestroyed) {
        if (
          this.prodOutMasterList != null &&
          this.prodOutMasterList.length > 0
        ) {
          let para = this.prodOutMasterList.map((item) => item.Code);
          getProdSchedule(para)
            .then((res) => {
              if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response != null
              ) {
                this.prodScheduleList = res.data.response;
              }
            })
            .finally(() => {
              this.prodScheduleAuto = setTimeout(() => {
                this.GetProdSchedule();
              }, 7000);
            });
        } else {
          this.prodScheduleAuto = setTimeout(() => {
            this.GetProdSchedule();
          }, 1000);
        }
      }
    },
    //计算生产进度
    computeProdSpeed(prodOutMasterItem) {
      if (prodOutMasterItem) {
        var maxItem = this.prodScheduleList.filter(
          (e) => e.Code == prodOutMasterItem.Code
        );
        if (maxItem && maxItem.length > 0 && prodOutMasterItem.ItemNo > 0) {
          var itemNumber = Number(
            (maxItem[0].NowItemNum / prodOutMasterItem.ItemNo) * 100
          ).toFixed(0);
          if (itemNumber == 100) {
            if (
              this.prodOutMasterList != null &&
              this.prodOutMasterList.length > 0
            ) {
              this.prodOutMasterList.map((e) => {
                if (e.Code == maxItem[0].Code) {
                  e.Status = 200;
                }
              });
            }
          }
          return itemNumber;
        }
      }
      return 0;
    },
    changeCar() {
      this.getVehicleList();
    },
    // 获取任务单信息
    getTaskList() {
      var startPlanDate = null;
      var endPlanDate = null;
      if (this.planDateArr && this.planDateArr.length > 0) {
        startPlanDate = this.planDateArr[0];
        if (this.planDateArr.length > 1) {
          endPlanDate = this.planDateArr[1];
        }
      }
      let para = {
        page: this.page,
        key: this.searchText,
        taskStatus: this.taskStatus,
        startPlanDate: startPlanDate,
        endPlanDate: endPlanDate,
        intPageSize: this.pageSize,
        orgCode: this.orgCode,
        orgId: this.orgId,
      };
      this.listLoading = true;
      getTaskListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.taskList = res.data.response.data;
        this.listLoading = false;
      });
    },
    //获取右侧任务单所对应生产出货单
    getProdConsoleList() {
      let para = {
        taskId: this.currentTaskId,
      };
      this.listLoading = true;
      this.prodOutMasterList = [];
      getProdConsoleListPage(para).then((res) => {
        this.prodOutMasterList = res.data.response;
      });
    },
    taskdetail(taskId) {
      if (taskId != "") {
        this.checktask = this.taskList.filter((e) => e.Id == taskId)[0];
        this.currentTaskId = taskId;
      } else {
        this.currentTaskId = "";
      }

      this.getProdConsoleList();
    },
    search() {
      this.getTaskList();
    },

    // 任务单菜单
    taskMenu(i, item) {
      if (i == -99) {
        this.selectCode = item.Code;
        this.historyListShow = true;
      } else {
        item.TaskStatus = i;
        let para = Object.assign({}, item);
        editProdTask(para)
          .then((res) => {
            if (res && res.data && res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.getTaskList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .finally(() => {
            this.addLoading = false;
          });
      }
    },

    // 生产线菜单
    stationLineMenu(i, item) {
      if (i == 1) {
        this.backOutMaster(item.Id);
      } else if (i == 2) {
        this.cancelOutMaster(item.Id);
      } else if (i == 3) {
        this.print(item.Id);
      } else if (i == 4) {
        this.getManufacture(item);
      }
    },
    // 单据回站
    backOutMaster(id) {
      this.listLoading = true;
      putProdConsoleBackOutMaster(id).then((res) => {
        this.listLoading = false;
        if (res && res.data && res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.getVehicleList();
        this.getProdConsoleList();
      });
    },
    // 车辆回站
    backVehicle(id) {
      this.listLoading = true;
      putackVehicle(id).then((res) => {
        this.listLoading = false;
        if (res && res.data && res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.getVehicleList();
        this.getProdConsoleList();
      });
    },
    // 取消出货单调度
    cancelOutMaster(id) {
      this.listLoading = true;
      putProdConsoleCancelOutMaster(id).then((res) => {
        this.listLoading = false;
        if (res && res.data && res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.getVehicleList();
        this.getProdConsoleList();
      });
    },
    //获取待排车辆
    GetWaitVehicle() {
      getWaitVehicle().then((res) => {
        this.WaitVehicle = res.data.response;
        if (this.checkVehicleId != "") {
          this.changeVehicle();
        }
      });
    },
    changeVehicle() {
      if (this.checkVehicleId) {
        this.addForm.VehicleID = this.checkVehicleId;
        this.checkVehicleId = "";
      }
      var vehicleItem = this.WaitVehicle.filter(
        (e) => e.Id == this.addForm.VehicleID
      )[0];
      if (vehicleItem) {
        this.addForm.VehicleErpCode = vehicleItem.ErpCode;
        var quantity =
          vehicleItem.Quantity == "" || vehicleItem.Quantity == undefined
            ? 0
            : Number(vehicleItem.Quantity);
        var remainQuantity =
          vehicleItem.RemainQuantity == "" ||
          vehicleItem.RemainQuantity == undefined
            ? 0
            : Number(vehicleItem.RemainQuantity);
        this.addForm.TQuantity = Number(quantity - remainQuantity).toFixed(2);

        this.changequantity();

        this.GetVehicleWorker(this.addForm.VehicleID);
      }
    },
    //获取当班司机
    GetVehicleWorker(id) {
      let para = {
        key: id,
      };
      getVehicleWorker(para).then((res) => {
        this.VehicleWorker = res.data.response.data;
        if (res.data.response.data) {
          var checkWorker = res.data.response.data.filter(
            (e) => e.WorkerType == 1
          );
          if (checkWorker && checkWorker.length > 0) {
            this.addForm.DriverName = checkWorker[0].WorkerName;
            this.addForm.DriverID = checkWorker[0].WorkerID;
          }
        }
      });
    },
    //选择当班司机
    changeVehicleWorker(id) {
      var workerItem = this.VehicleWorker.filter((e) => e.Id == id)[0];
      this.addForm.DriverName = workerItem.WorkerName;
    },
    //调度页面打开
    showProdOutMaster(task) {
      this.addForm = {
        TaskCode: task.Code,
        TaskID: task.Id,
        ClientName: task.ClientName,
        ClientID: task.ClientID,
        ProjectName: task.ProjectName,
        ProjectID: task.ProjectID,
        BillType: 0,
        ProejctAddress: task.ConstructionAddress,
        ProjectPart: task.ProjectPart,
        SpecMtlName: task.SpecMtlName,
        SpecMtlID: task.SpecMtlID,
        TLD: task.TLD,
        GradeName: task.GradeName,
        GradeID: task.GradeID,
        PouringMethodName: task.WorkMethodName,
        PouringMethodID: task.WorkMethodID,
        ContactsName: task.ContactName,
        ContactsPhone: task.ContactPhone,
        OrgID: this.orgId,
        OrgCode: this.orgCode,
        OrgName: this.orgName,
        DriverName: "",
        DriverID: "",
        TQuantity: 0,
        VehicleErpCode: "",
        QuantityDelivery: 0,
      };
      // this.addForm.TaskCode = task.Code;
      // this.addForm.TaskID = task.Id;
      // this.addForm.ClientName = task.ClientName;
      // this.addForm.ClientID = task.ClientID;
      // this.addForm.ProjectName = task.ProjectName;
      // this.addForm.ProjectID = task.ProjectID;
      // this.addForm.BillType = 0;
      // this.addForm.ProejctAddress = task.ConstructionAddress;
      // this.addForm.ProjectPart = task.ProjectPart;
      // this.addForm.SpecMtlName = task.SpecMtlName;
      // this.addForm.SpecMtlID = task.SpecMtlID;
      // this.addForm.TLD = task.TLD;
      // this.addForm.GradeName = task.GradeName;
      // this.addForm.GradeID = task.GradeID;
      // this.addForm.PouringMethodName = task.WorkMethodName;
      // this.addForm.PouringMethodID = task.WorkMethodID;
      // this.addForm.ContactsName = task.ContactName;
      // this.addForm.ContactsPhone = task.ContactPhone;
      // this.addForm.OrgID = this.orgId;
      // this.addForm.OrgCode = this.orgCode;
      // this.addForm.OrgName = this.orgName;
      if (task.SpecMtlID) {
        this.specMtlID = task.SpecMtlID.split(",");
        this.specMtlName = task.SpecMtlName.split(",");
        this.specMtlIDList = this.specMtlID;
      } else {
        this.specMtlID = [];
        this.specMtlName = [];
        this.specMtlIDList = [];
      }

      this.addFormVisible = true;
      var pushStationLine = [];
      if (task.RecipeCodes) {
        //-1表示任务单无需配比可调度
        if (task.RecipeCodes == "-1") {
          this.stationLine.map((e) => {
            pushStationLine.push(e);
          });
        } else {
          var stationLineTask = JSON.parse(task.RecipeCodes);
          this.stationLine.map((e) => {
            stationLineTask.map((k) => {
              if (k.StationLineID == e.Id) {
                pushStationLine.push(e);
              }
            });
          });
        }
      }
      this.stationLineDispatch = pushStationLine;
      if (pushStationLine && pushStationLine.length > 0) {
        this.addForm.StationLineID = pushStationLine[0].Id;
        this.addForm.StationLineName = pushStationLine[0].Name;
      }
      if (window.localStorage.Operator) {
        var operatorList = JSON.parse(window.localStorage.Operator);
        if (operatorList && operatorList.length > 0) {
          var operatordM = operatorList.filter(
            (e) => e.StationLineID == this.addForm.StationLineID
          );
          if (operatordM && operatordM.length > 0) {
            this.addForm.OperatorID = operatordM[0].OperatorID;
            this.addForm.OperatorName = operatordM[0].OperatorName;
          }
        }
      }

      this.GetWaitVehicle();
    },
    //执行新增/编辑
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          addVehicleDispatch(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.taskdetail(this.addForm.TaskID);
                this.addForm = {};
                this.getVehicleList();
                this.getTaskList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    getBaseData() {
      getGetProdOutMasterBaseData().then((res) => {
        this.baseData = res.data.response;
      });
    },
    //强度等级改变时触发
    selectGrade(id) {
      var value = this.baseData.GradeList.filter((e) => e.Id == id)[0];
      this.addForm.GradeID = value.Id;
      this.addForm.GradeName = value.Name;
    },
    //浇筑方式改变时触发
    selectPouringMethod(id) {},
    //特殊材料选择
    changeSpecialMaterial(value, isTrue) {
      if (isTrue) {
        this.specMtlID.push(value.Id);
        this.specMtlName.push(value.Name);
      } else {
        this.specMtlID.splice(
          this.specMtlID.findIndex((x) => x === value.Id),
          1
        );
        this.specMtlName.splice(
          this.specMtlName.findIndex((x) => x === value.Name),
          1
        );
      }
      this.addForm.SpecMtlID = this.specMtlID.toString();
      this.addForm.SpecMtlName = this.specMtlName.toString();
    },
    selectStation(id) {
      this.addForm.StationLineID = id;
      this.addForm.StationLineName = this.stationLineDispatch.filter(
        (e) => e.Id == id
      )[0].Name;
      if (window.localStorage.Operator) {
        var operatorList = JSON.parse(window.localStorage.Operator);
        if (operatorList && operatorList.length > 0) {
          var operatordM = operatorList.filter(
            (e) => e.StationLineID == this.addForm.StationLineID
          );
          if (operatordM && operatordM.length > 0) {
            this.addForm.OperatorID = operatordM[0].OperatorID;
            this.addForm.OperatorName = operatordM[0].OperatorName;
          }
        }
      }
    },
    print(id) {
      let para = {
        id: id,
      };
      getPrintContent(para).then((res) => {
        this.listLoading = false;
        if (res.data.success) {
          runReport(
            res.data.response.PrintEntity,
            res.data.response.PrintModel
          );
            let syles = "";
            if (document.styleSheets.length > 1) {
              for (let i = document.styleSheets.length - 1; i >= 0; i--) {
                if (
                  document.styleSheets[i].ownerNode.id.indexOf("gridcss") > 0
                ) {
                  let rulesList = document.styleSheets[i].cssRules;
                  for (let j = 0; j < rulesList.length; j++) {
                    syles += rulesList[j].cssText;
                  }
                  break;
                }
              }
            }
            printJS({
              printable: "report_holder",
              type: "html",
              header: null,
              targetStyles: ["*"],
              style: syles,
              scanStyles: false,
            });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    getManufacture(item) {
      this.manufactureFormVisible = true;
      let row = item;
      this.manufactureMaster = item;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });

        return;
      }
      this.isEdit = true;
      let para = {
        outmasterCode: row.Code,
      };
      getManufactureDetail(para).then((res) => {
        this.listLoading = false;
        this.Prodmanufacturemains = res.data.response.Prodmanufacturemains;
        if (res.data.response.ProdRecipe) {
          this.ProdRecipeMain.ProdRecipe = res.data.response.ProdRecipe;
          //this.ProdRecipeMain.ProdRecipeSubs = res.data.response.ProdRecipeSubs;
        }
        if (res.data.response.ProdRecipeSubs) {
          res.data.response.ProdRecipeSubs.map((e) => {
            this.ProdRecipeMain.QuantityRecipeSum += Number(
              e.Quantity == null ? 0 : e.Quantity
            );
            this.ProdRecipeMain.QuantityActualSum += Number(
              e.ActualQuantity == null ? 0 : e.ActualQuantity
            );
          });
        }
        this.Prodmanufacturemains.map((e) => {
          var prodmanufacturesubs = [];
          e.Prodmanufacturesubs.map((k) => {
            prodmanufacturesubs.push({
              MatName: k.MatName,
              MatID: k.MatID,
              WarehouseName: k.WarehouseName,
              WarehouseID: k.WarehouseID,
              Quantity: k.Quantity,
              ActualQuantity: k.ActualQuantity,
              QuantityRate:
                k.Quantity > 0
                  ? (
                      Number((k.ActualQuantity - k.Quantity) / k.Quantity) * 100
                    ).toFixed(3)
                  : 0,
            });
            e.Prodmanufacturesubs = prodmanufacturesubs;
          });
        });
      });
    },
    //获取生产线列表
    getSysStationLineList() {
      let para = {
        key: this.orgId,
      };
      this.listLoading = true;
      getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
          if (res.data.response.data.length > 0) {
            this.addForm.StationLineID = this.stationLine[0].Id;
            this.addForm.StationLineName = this.stationLine[0].Name;
          } else {
            this.addForm.StationLineID = null;
            this.addForm.StationLineName = null;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    hrdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.DriverID = data[0].Id;
        this.addForm.DriverName = data[0].Name;
      }
      this.hrvisibleDialog = false;
    },
    hrqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    hrsetVisible(val) {
      this.hrvisibleDialog = val;
    },
    opdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.OperatorID = data[0].Id;
        this.addForm.OperatorName = data[0].Name;
        var operatordM = {
          OperatorID: data[0].Id,
          OperatorName: data[0].Name,
          StationLineID: this.addForm.StationLineID,
        };
        var operatorlist = [];
        let saveoperators = [];
        if (window.localStorage.Operator) {
          operatorlist = JSON.parse(window.localStorage.Operator);
          if (operatorlist && operatorlist.length > 0) {
            var checkOp = operatorlist.filter(
              (k) => k.StationLineID == this.addForm.StationLineID
            );
            if (checkOp && checkOp.length > 0) {
              operatorlist.map((e) => {
                if (e.StationLineID == this.addForm.StationLineID) {
                  e = operatordM;
                }
                saveoperators.push(e);
              });
            } else {
              saveoperators.push(operatordM);
            }
          } else {
            saveoperators.push(operatordM);
          }
        } else {
          saveoperators.push(operatordM);
        }
        window.localStorage.Operator = JSON.stringify(saveoperators);
      }
      this.opvisibleDialog = false;
    },
    opqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    opsetVisible(val) {
      this.opvisibleDialog = val;
    },
    vedialogCallback(data) {
      if (data.length > 0) {
        this.addForm.VehicleID = data[0].Id;
        this.addForm.VehicleErpCode = data[0].ErpCode;
      }
      this.vevisibleDialog = false;
    },
    vequeryData(params) {
      return VehicleListPage(params);
    },
    vesetVisible(val) {
      this.vevisibleDialog = val;
    },
    showMenu(car) {},

    timeToMDHm(timestr) {
      let time = null;
      if (!timestr) {
        time = new Date();
      } else {
        time = new Date(timestr);
      }
      return util.formatDate.format(time, "MM-dd hh:mm");
    },
    ///=改变用量时触发重算发货方量
    changequantity() {
      var tquantity =
        this.addForm.TQuantity == "" || this.addForm.TQuantity == undefined
          ? 0
          : Number(this.addForm.TQuantity);
      var squantity =
        this.addForm.SQuantity == "" || this.addForm.SQuantity == undefined
          ? 0
          : Number(this.addForm.SQuantity);
      this.addForm.QuantityDelivery = tquantity + squantity;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ * {
  font-family: "MicroSoft-YaHei", Tahoma, Geneva, Verdana, sans-serif;
}
.car-area {
  display: flex;
  flex-wrap: wrap;
  justify-items: left;

  .car-btn {
    cursor: pointer;
    user-select: none;
    color: #fff;
    display: flex;
    width: 40px;
    height: 40px;
    background: #409eff;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 4px;
  }
}
/deep/ .task-area {
  flex-wrap: wrap;
  // .task.el-col {
  //   // width: 30%;
  // }
  .box-card {
    width: 100%;
    margin: 10px 0;
    background: rgb(242, 242, 244);
    .el-card__body {
      padding: 5px;
      .info {
        background: #fff;
        border-radius: 6px;
        margin: 3px;
        padding: 3px;
        font-size: 0.8rem;
        .row {
          display: flex;
          justify-content: left;
          margin: 4px 0;
          .key {
            color: #bebebe;
            margin-right: 5px;
          }
          .value {
            color: #222;
          }
          &.between {
            justify-content: space-between;
          }
        }
      }
      .progress-area {
        margin-top: 10px;
        font-size: 14px;
        display: flex;
        align-items: center;
      }
    }
  }
}

.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.station-area {
  margin-top: 20px;
  margin-left: 5px;
  max-height: 700px;
  overflow: auto;
  .station-card {
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dcdfe6;
    .station-card-row {
      /deep/ .dropdown-btn {
        min-width: 75px;
      }
      span {
        width: 25%;
        text-align: center;
        font-size: 0.8rem;
        &.btn {
          cursor: pointer;
          width: 15%;
          margin: 0 5%;
          border-radius: 3px;
          color: #3a8ee6;
          border: 1px solid #3a8ee6;
        }
      }
    }
  }
}

/deep/ .disReport {
  padding: 10px;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%), 0 0 6px 0 rgb(0 0 0 / 4%);
  .row {
    display: flex;
    justify-content: center;
    .key {
      min-width: 85px;
      text-align: right;
      margin-right: 10px;
    }
  }
}

.add-dialog-car-area,
.add-dialog-driver-area {
  padding: 0 10px;
  height: 70px;
  overflow: auto;
  margin-bottom: 10px;
  /deep/ .el-radio {
    margin: 10px;
    margin-top: 0px;
    min-width: 85px;
    .el-radio__input {
      display: none;
    }
  }
}
.add-dialog-driver-area {
  height: auto !important;
  /deep/ .el-radio {
    min-width: 0;
  }
}
</style>
